// Generated by purs version 0.15.16
import * as $foreign from "./foreign.js";
import * as Data_Either from "../Data.Either/index.js";
var jsonParser = function (j) {
    return $foreign["_jsonParser"](Data_Either.Left.create, Data_Either.Right.create, j);
};
export {
    jsonParser
};
//# sourceMappingURL=index.js.map
